import React from "react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

export const DayLegend = ({ jours, activeDay, onSelectDay }) => {
  return (
    <div
      className="flex items-center gap-2 overflow-x-auto pb-1 voyage-legend-scroll"
      data-testid="map-day-legend"
    >
      <button
        onClick={() => onSelectDay(null)}
        className="flex-shrink-0 text-xs px-3 py-1.5 rounded-full border transition-all"
        style={{
          ...LORA,
          borderColor: activeDay === null ? "#C17F59" : "#DCD4C6",
          background: activeDay === null ? "#C17F59" : "transparent",
          color: activeDay === null ? "#F9F6F0" : "#9A8F86",
        }}
        data-testid="legend-all-days"
      >
        Tous les jours
      </button>

      {jours.map((j) => {
        const active = activeDay === j.numero_jour;
        return (
          <button
            key={j.numero_jour}
            onClick={() => onSelectDay(j.numero_jour)}
            className="flex-shrink-0 flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border transition-all"
            style={{
              ...LORA,
              borderColor: active ? j.couleur : "#DCD4C6",
              background: active ? `${j.couleur}1A` : "transparent",
              color: active ? "#2B2623" : "#9A8F86",
            }}
            data-testid={`legend-day-${j.numero_jour}`}
          >
            <span
              className="w-2.5 h-2.5 rounded-full flex-shrink-0"
              style={{ backgroundColor: j.couleur }}
            />
            Jour {j.numero_jour}
          </button>
        );
      })}
    </div>
  );
};
